module.exports = __webpack_public_path__ + "img/bg2x.759fb747.jpg";